export const REDIRECT_TO_CLEAR = [
  {
    origin: '/operation/sales',
    pathToClear: [
      '/operations/sales/documents',
      '/stock',
      '/stock/point-of-sale',
      '/operations/sales/documents/pending',
      '/bill/sales/document/pending',
      '/bill/sales/document/emit',
      '/cash-registers',
      '/dashboard/user-sales-month'
    ]
  },
  {
    origin: '/operations/purchase-order',
    pathToClear: [
      '/operations/purchase-order-reception',
      '/operations/purchase-order-reception/details',
      '/operations/purchase-order-reception/documents'
    ]
  },
  {
    origin: '/operations/purchase-order-reception',
    pathToClear: [
      '/operations/purchase-order',
      '/operations/purchase-order/details',
      '/operations/purchase-order/documents'
    ]
  },
  {
    origin: '/operations/purchases',
    pathToClear: [
      '/warehouse',
      '/stock',
      '/stock/point-of-sale',
      '/operations/purchases/documents'
    ]
  },
  {
    origin: '/operation/transfers',
    pathToClear: [
      '/operations/transfers/documents/pending',
      '/operations/transfers/documents',
      '/operations/transferss/detail',
      '/stock',
      '/stock/point-of-sale'
    ]
  },
  {
    origin: '/bill/sales/document/emit',
    pathToClear: ['/bill/sales/document/pending']
  },
  {
    origin: '/points-of-sale',
    pathToClear: ['/points-of-sale/free']
  },
  {
    origin: '/inventory',
    pathToClear: ['/warehouse']
  },
  {
    origin: '/cash-registers',
    pathToClear: [
      '/cash-registers/active/user',
      '/cash-registers/active',
      '/points-of-sale',
      '/points-of-sale/free'
    ]
  },
  {
    origin: '/stock',
    pathToClear: ['/stock/point-of-sale']
  },
  {
    origin: '/operation-auxiliary/cancellation',
    pathToClear: [
      '/operations/sales/documents',
      '/operations/sales/documents/pending',
      '/cash-registers',
      '/cash-registers/active',
      '/cash-registers/active/user',
      '/stock',
      '/stock/point-of-sale'
    ]
  },
  {
    origin: '/operation-auxiliary/join-sale-note',
    pathToClear: [
      '/operations/sales/documents/pending',
      '/bill/sales/document/pending',
      '/bill/sales/document/emit'
    ]
  },
  {
    origin: '/bill/credit-notes/emit',
    pathToClear: [
      '/bill/sales/document/emit',
      '/stock',
      '/stock/point-of-sale',
      '/cash-registers',
      '/cash-registers/active/user',
      '/cash-registers/active'
    ]
  },
  {
    origin: '/auth/logout',
    pathToClear: [
      '/cash-registers',
      '/cash-registers/active',
      '/cash-registers/active/user',
      '/users/active',
      '/stock',
      '/stock/point-of-sale',
      '/points-of-sale',
      '/points-of-sale/free'
    ]
  }
];
